import { render, staticRenderFns } from "./MasterDocument.vue?vue&type=template&id=68b2a436"
import script from "./MasterDocument.vue?vue&type=script&lang=js"
export * from "./MasterDocument.vue?vue&type=script&lang=js"
import style0 from "./MasterDocument.vue?vue&type=style&index=0&id=68b2a436&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports